import { PermissionMatrixMutations } from './partials/matrix'
import { PermissionsRoleMutations } from './partials/role'
import { ResourceMutations } from './partials/resources'
import { TeamMutations } from './partials/team'

export const PermissionMutations = {
  ...PermissionMatrixMutations,
  ...PermissionsRoleMutations,
  ...ResourceMutations,
  ...TeamMutations,
}
